module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/changeLogs/ChangeLog.ejs -->\n<td>'+
((__t=( moment(model.get('changeTime')).format('DD-MM-YYYY HH:mm') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( description ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('userName') ))==null?'':_.escape(__t))+
'</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/changeLogs/ChangeLog.ejs
// module id = 671
// module chunks = 1